import "./Banner.css";

function Banner({
  image,
  title,
  subtitle,
  location,
  learnMoreLink,
  registerLink,
  primaryColor = "#008acf",
  secondaryColor = "#ffffff",
  showButtons = true,
  variant = "default",
}) {
  const hexToRgb = (hex) => {
    let cleanHex = hex.replace("#", "");
    if (cleanHex.length === 3) {
      cleanHex = cleanHex.split("").map(c => c + c).join("");
    }
    const bigint = parseInt(cleanHex, 16);
    return `${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255}`;
  };
  const imageSrc = typeof image === "object" && image !== null ? image.default : image;

  return (
    <div id="banner" className={`banner ${variant === "card" ? "card" : ""}`}>
      <img
        src={imageSrc}
        alt={typeof title === "string" ? title : "banner"}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />

      <div className="banner-content">
        <div></div>

        <div className="text-container">
          <h1 className="banner-title">{title}</h1>

          <p className="banner-subtitle">{subtitle}</p>

          <br />

          <a href="#map-section" className="banner-subtitle location">
            <span className="material-symbols">explore_nearby</span>
            {location}
          </a>
        </div>

        {showButtons && (
          <div className="button-container">
            <a
              href={learnMoreLink}
              className="learn-more-button">
              Learn More
            </a>
            <a
              href={registerLink}
              className="register-button"
              style={{
                "--accent-color-rgb": hexToRgb(primaryColor),
                color: secondaryColor,
              }}>
              Register Now
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default Banner;
